module.exports = __webpack_public_path__ + "img/9_uk.631ca77c.svg";